<div class="flex h-full w-full items-center justify-center bg-gray-50">
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" class="opacity-30">
    <rect class="stroke-error-toaster-content" x="3" y="4" width="18" height="16" rx="2" stroke-width="1.5" />
    <path
      class="stroke-error-toaster-content"
      d="M21 15l-5-5L5 21"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <circle class="stroke-error-toaster-content" cx="8.5" cy="8.5" r="1.5" stroke-width="1.5" />
  </svg>
</div>
